
@for (list of detailContent.lists; track list.id) {
  @if (list.items.length && !hiddenFieldsets.includes(list.id)) {
    @if (list.title) {
      <div class="proto-list-note proto-list-note--inset is-top">{{ list.title | translate }}</div>
    }

    <ion-list class="detail-list detail-list--{{list.id}}" inset>
      @for (item of list.items; track item.id) {
        <detail-list-item [item]="item"
          [isUnauthorized]="isUnauthorized"
          [useIcon]="list.id === 'contact' || list.id === 'organization-co-information' || list.id === 'contactPersons'"
          [ngClass]="{
            'nested-item': item.valueType === 'nestedArray',
            'is-stacked': list.id === 'topics' || list.id === 'additionalInformation' }"/>
      }
    </ion-list>
  }
}
